import type { FC, ReactNode } from 'react'

import { SectionHeading } from '@/components/landing/section-heading'
import { HOUSE_CODES } from '@/constants/landing'

export const CodesSection: FC = (): ReactNode => {
    return (
        <section id='codes' aria-labelledby='codes-title' className='relative isolate overflow-hidden py-24 sm:py-32'>
            <div aria-hidden='true' className='absolute inset-0 -z-10'>
                <div className='ambient-orb left-[8%] top-1/3 size-[26rem] bg-champagne/80' />
                <div className='ambient-orb right-[6%] top-[45%] size-[24rem] bg-gold/35 [animation-delay:-9s]' />
                <div className='ambient-orb bottom-[-8rem] left-1/2 size-[22rem] bg-stone/70 [animation-delay:-4s]' />
            </div>

            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='codes-title'
                    align='center'
                    eyebrow="The Aveline codes"
                    title={<>Four promises, <em className='text-gilded'>kept since 1908</em></>}
                    description="They are written on the wall of every atelier, and every artisan learns them before they learn to hold a knife."
                />

                <ul className='mt-16 grid gap-5 sm:grid-cols-2 xl:grid-cols-4'>
                    {HOUSE_CODES.map((code, index) => {
                        const Icon = code.icon

                        return (
                            <li key={code.title} className='glass reveal flex flex-col rounded-[2rem] p-7 text-espresso sm:p-8'>
                                <div className='flex items-center justify-between'>
                                    <span className='flex size-12 items-center justify-center rounded-full bg-white/70 ring-1 ring-espresso/10'>
                                        <Icon className='size-5 text-gold-deep' strokeWidth={1.4} />
                                    </span>

                                    <span className='font-heading text-lg italic text-espresso/40'>
                                        {String(index + 1).padStart(2, '0')}
                                    </span>
                                </div>

                                <h3 className='mt-12 font-heading text-[2rem] font-normal leading-none'>
                                    {code.title}
                                </h3>

                                <p className='mt-4 text-sm leading-relaxed text-muted-foreground'>
                                    {code.text}
                                </p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </section>
    )
}
